import styles from "../WorkoutAdminModal.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark, faPlus, faSpinner } from "@fortawesome/free-solid-svg-icons";
import { parseRepsPerSet, formatRepsPerSet, parseRestPerSet, formatRestPerSet } from "./workoutAdminHelpers";

// Presets de série/descanso (ver app/models/workout_preset.py) como chips
// clicáveis direto no form de incluir/editar exercício — 1 clique aplica,
// sem abrir uma lista à parte pra buscar e confirmar (essa versão anterior,
// testada em produção, não funcionou bem: um passo a mais pra um atalho que
// devia ser imediato — Fitts's Law/Hick's Law, ver knowledge/02-laws-of-ux
// do ux-product-designer). "target" (plan/assignment/anon) já vem embutido
// no onApply que cada chamador passa — este componente é só apresentação.
export default function PresetPickerInline({
  presets,
  loading,
  onApply,
  onDelete,
  showCreateForm,
  onToggleCreateForm,
  newPresetForm,
  onChangeNewPresetForm,
  onSubmitCreate,
  saving,
}) {
return (
  <div className={styles.wamField}>
    <label>Presets de série/descanso</label>
    <div className={styles.presetChipsRow}>
      {loading && <span className={styles.wamFieldHint}>Carregando presets…</span>}
      {!loading && presets.map((preset) => (
        <span
          key={preset.id}
          className={`${styles.presetChip} ${preset.professor_id != null ? styles.presetChipOwn : styles.presetChipStandard}`}
          title={preset.description || preset.name}
        >
          <button type="button" className={styles.presetChipMain} onClick={() => onApply(preset)}>
            {preset.name}
          </button>
          {preset.professor_id != null && (
            <button
              type="button"
              className={styles.presetChipRemove}
              onClick={() => onDelete(preset)}
              aria-label={`Remover preset ${preset.name}`}
            >
              <FontAwesomeIcon icon={faXmark} />
            </button>
          )}
        </span>
      ))}
      <button
        type="button"
        className={styles.presetChipCreate}
        onClick={onToggleCreateForm}
      >
        <FontAwesomeIcon icon={showCreateForm ? faXmark : faPlus} /> {showCreateForm ? "Cancelar" : "Criar preset"}
      </button>
    </div>

    {showCreateForm && (
      <div className={styles.presetCreatePanel}>
        <div className={styles.wamField}>
          <label>Nome do preset</label>
          <input
            type="text"
            value={newPresetForm.name}
            onChange={(e) => onChangeNewPresetForm({ ...newPresetForm, name: e.target.value })}
            placeholder="Ex.: Drop set curto"
          />
        </div>
        {/* Mesma UI do preenchimento manual (ver setsRepsRow em "Incluir
            exercício") — Séries + grade "por série" pra repetições e
            descanso, em vez de um campo de texto solto com vírgulas. */}
        <div className={styles.setsRepsRow}>
          <div className={styles.wamField} style={{ width: 80, flexShrink: 0 }}>
            <label>Séries</label>
            <input
              type="number"
              min={1}
              max={20}
              value={newPresetForm.sets_planned}
              onChange={(e) => {
                const n = Number(e.target.value) || 0;
                onChangeNewPresetForm({
                  ...newPresetForm,
                  sets_planned: e.target.value,
                  reps_per_set: parseRepsPerSet(newPresetForm.reps_planned, n),
                  rest_per_set: parseRestPerSet(newPresetForm.rest_seconds, n),
                });
              }}
            />
          </div>

          {newPresetForm.sets_planned > 0 && (
            <div className={styles.repsPerSetSection}>
              <label className={styles.repsPerSetSectionLabel}>Repetições por série</label>
              <div className={styles.repsPerSetRow}>
                {Array.from({ length: Number(newPresetForm.sets_planned) }).map((_, i) => (
                  <div key={i} className={styles.repsPerSetItem}>
                    <span className={styles.repsPerSetLabel}>S{i + 1}</span>
                    <input
                      type="text"
                      className={styles.repsPerSetInput}
                      value={newPresetForm.reps_per_set[i] ?? ""}
                      placeholder="-"
                      onChange={(e) => {
                        const arr = [...newPresetForm.reps_per_set];
                        arr[i] = e.target.value;
                        onChangeNewPresetForm({ ...newPresetForm, reps_per_set: arr, reps_planned: formatRepsPerSet(arr) });
                      }}
                    />
                  </div>
                ))}
              </div>
            </div>
          )}

          {newPresetForm.sets_planned > 0 && (
            <div className={styles.repsPerSetSection}>
              <label className={styles.repsPerSetSectionLabel}>Descanso por série (s)</label>
              <div className={styles.repsPerSetRow}>
                {Array.from({ length: Number(newPresetForm.sets_planned) }).map((_, i) => (
                  <div key={i} className={styles.repsPerSetItem}>
                    <span className={styles.repsPerSetLabel}>S{i + 1}</span>
                    <input
                      type="number"
                      className={styles.repsPerSetInput}
                      value={newPresetForm.rest_per_set[i] ?? ""}
                      placeholder="-"
                      onChange={(e) => {
                        const arr = [...newPresetForm.rest_per_set];
                        arr[i] = e.target.value;
                        onChangeNewPresetForm({ ...newPresetForm, rest_per_set: arr, rest_seconds: formatRestPerSet(arr) });
                      }}
                    />
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
        <div className={styles.wamField}>
          <label>Observações (aplicadas ao exercício)</label>
          <textarea
            rows="2"
            value={newPresetForm.notes}
            onChange={(e) => onChangeNewPresetForm({ ...newPresetForm, notes: e.target.value })}
            placeholder="Orientação de execução"
          />
        </div>
        <div className={styles.actionsRow}>
          <button
            type="button"
            className={`${styles.wamBtn} ${styles.primary} ${styles.wamBtnSm}`}
            onClick={onSubmitCreate}
            disabled={saving}
          >
            {saving ? <FontAwesomeIcon icon={faSpinner} spin /> : "Salvar preset"}
          </button>
        </div>
      </div>
    )}
  </div>
);
}
